<h2 class="mb-2" [innerHTML]="data.title | translate" *ngIf="!!data.title"></h2>

<div>
    <i class="material-icons mr-1 align-middle warning-icon" *ngIf="data.isErrore">warning</i>
    <span class="font-weight-bold align-middle" [innerHTML]="data.message | translate: data.messageParams"></span>
</div>

<div class="text-right mt-2">
    <button mat-flat-button color="blank" class="mr-1" [matDialogClose] (click)="btnOkClick()" cdkFocusInitial>{{ data.okButtonText  | translate }}</button>
    <button mat-flat-button color="blank" [matDialogClose] (click)="reject()" *ngIf="!isNascondiAnnulla()">{{ data.cancelButtonText  | translate }}</button>
</div>